import * as Types from '../actions/types';

export default function (state={},action){
    switch(action.type){
        case Types.LOGIN:
            return {authenticated:true,token:action.payload.ID,authoriseFlow:false};
        case Types.LOGOUT:
            return {authenticated:false};
        case Types.LOGIN_ERROR:
            return {error:true};
        case Types.AUTH_ERROR:
            return {authError:true}
        case Types.AUTHENTICATING:
            return {authenticating:true};
        case Types.RESETTING_PASSWORD:
            return {resetting:true}
        case Types.PASSWORD_RESET:
            return {reset:true};
        case Types.RESET_ERROR:
            return {reseterror:true};
        case Types.CLEAR_AUTH:
            return {};
        case Types.SET_REDIRECT_TO:
            return {...state, redirect:action.payload};
        case Types.GET_URL:
            return {...state, secret: action.payload};
        case Types.LOADING_APPS:
            return {...state,loaded:false};
        case Types.FETCH_APPS:
            return {...state,authoriseFlow:false,loaded:true};
        case Types.LOOKING_UP_AUTH_APP:
            return {...state,authoriseFlow:true};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js